export default __webpack_public_path__ + "static/Maribel-39d41f51397103c31900b259e5e7b8c9842b411af60d2bafda01d18dc3bb445f.svg";